import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=66176ba8&scoped=true&"
import script from "./MessagePopup.vue?vue&type=script&lang=js&"
export * from "./MessagePopup.vue?vue&type=script&lang=js&"
import style0 from "./MessagePopup.vue?vue&type=style&index=0&id=66176ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66176ba8",
  null
  
)

export default component.exports